import React from "react";

const SideCard = (props) => {
  return (
    <div className="sideToggler-card" onClick={props.cardSlidOpener}>
      <div className="toggler-card-img">
        <img
          src="http://cdn1-media.s3.amazonaws.com/product_links/Product_Images/KAI05.jpg"
          width="100%"
          alt="Change Me Lorem Ipsum Dollar Lorem Ipsu"
        />
      </div>
      <div className="sideToggler-card-text">
        <h2 className="text-color normal-fonts">
          Change Me Lorem Ipsum Dollar Lorem Ipsu Lorem Ipsum Dollar Lorem Ipsu
        </h2>
      </div>
      <div className="sideToggler-card-sponcer">
        <p className="text-color normal-fonts">By Name here</p>
      </div>
      <div className="sideToggler-card-price">
        <span className="font-25">$12.34</span> &nbsp;
        <s className="normal-font text-grey">$55.66</s>
      </div>

      <ul className="d-flex flex-start align-center">
        <div className="reviewsStars d-flex">
          <img src="../assets/images/review-star.svg" />
        </div>
        <span className="ml-1 text-grey">1234</span>
      </ul>
    </div>
  );
};

export default SideCard;
